import FeaturedIcon from "../common/icons/featured_icon";
import PublicHeaderItem from "./public_header_item";
import Camera from '@/assets/svg/icons/camera.svg';
import Layout from '@/assets/svg/icons/layout.svg';
import Star from '@/assets/svg/icons/star.svg';
import MapPin from '@/assets/svg/icons/map-pin.svg';
import PublicHeaderProviderDropdown from "./public_header_provider_dropdown";
import PublicHeaderPlannerDropdown from "./public_header_planner_dropdown";

export default function PublicHeaderNavItems({onClick, is_mobile = false}) {
    return <>
        {is_mobile
            ? <>
                <PublicHeaderItem icon={<FeaturedIcon size={"md"} color={"gray"} icon={Camera} />} href="/szolgaltatok" onClick={onClick} is_mobile={is_mobile}>Szolgáltatók</PublicHeaderItem>
                <PublicHeaderItem icon={<FeaturedIcon size={"md"} color={"gray"} icon={Layout} />} href="/szervezom" onClick={onClick} is_mobile={is_mobile}>Szervezőm</PublicHeaderItem>
            </>
            : <>
                <PublicHeaderProviderDropdown />
                <PublicHeaderPlannerDropdown />
            </>
        }
        <PublicHeaderItem icon={<FeaturedIcon size={"md"} color={"gray"} icon={Star} />} href="/tippek-otletek" onClick={onClick} is_mobile={is_mobile}>Tippek és ötletek</PublicHeaderItem>
        <PublicHeaderItem icon={<FeaturedIcon size={"md"} color={"gray"} icon={MapPin} />} href="/hazassagkoto-terem" onClick={onClick} is_mobile={is_mobile}>Házasságkötő termek</PublicHeaderItem>
    </>
}
